module.exports = {"410822001":"博爱县清化镇","410822002":"博爱县鸿昌","410822101":"博爱县柏山镇","410822102":"博爱县月山镇","410822103":"博爱县许良镇","410822105":"博爱县磨头镇","410822106":"博爱县孝敬镇","410822200":"博爱县寨豁乡","410822203":"博爱县金城乡","410822400":"国营博爱农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410822.json
// module id = 1467
// module chunks = 0